module.exports = __webpack_public_path__ + "static/media/search.e375ac20.svg";